if (!customElements.get('td-product-add-to-cart-sticky')) {
    class TdProductAddToCartSticky extends HTMLElement {
      constructor() {
        super();
  
        this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
        this.body = document.querySelector('body')
        this.form = document.getElementById(`product-form-${this.dataset.section}`),
        this.footer = document.getElementById('footer');
      }
      connectedCallback() {
        setTimeout(() => {
          this.setupObservers();
          this.setupToggle(); 
        }, 0)
      
      }
      setupToggle() {
        const button = this.querySelector('.product-add-to-cart-sticky--inner'),
          content = this.querySelector('.product-add-to-cart-sticky--content');
  
        if (this.animations_enabled) {
          const tl = gsap.timeline({
            reversed: true,
            paused: true,
            onStart: () => {
              if(button) button.classList.add('sticky-open');
            },
            onReverseComplete: () => {
              if(button) button.classList.remove('sticky-open');
            }
          });
          if(content){
            tl
            .set(content, {
              display: 'block',
              height: 'auto'
            }, 'start')
            .from(content, {
              height: 0,
              duration: 0.25
            }, 'start+=0.001');
  
          }
          if(button){
            button.addEventListener('click', function() {
              tl.reversed() ? tl.play() : tl.reverse();
    
              return false;
            });
          }
          
        } else {
          if(button && content) {
            button.addEventListener('click', function() {
              content.classList.toggle('active');
              return false;
            });
          }
       
        }
  
  
      }
      setupObservers() {
        
        const  observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.target === footer) {
                if (entry.intersectionRatio > 0) {
                  this.classList.remove('sticky--visible');
                  
                } else if (entry.intersectionRatio == 0 && this.formPassed) {
                  this.classList.add('sticky--visible');
                 
                }
              }
              if (entry.target === form) {
                
                let boundingRect = form.getBoundingClientRect();
  
                if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                  this.formPassed = true;
                  this.classList.add('sticky--visible');
                  this.body.classList.add('sticky-atc-visible');
                } else if (entry.intersectionRatio === 1) {
                  this.formPassed = false;
                  this.classList.remove('sticky--visible');
                  this.body.classList.remove('sticky-atc-visible');
                }
              }
            });
          }, {
            threshold: [0, 1]
          }),
          form = this.form,
          footer = this.footer;
          this.formPassed = false;
          observer.observe(form);
          observer.observe(footer);
      }
    }
  
    customElements.define('td-product-add-to-cart-sticky', TdProductAddToCartSticky);
  }
  